<template>
    <div class="col-12 nopads">
        <top-bar
            @onSignInClicked="showLogin"
            @onSearchClicked="searchView"/>
        <alert
            :show="alertVisible"
            :message="message"
            :variant="variant"
            @alertShown=alertShown
            @alertDismiss="alertDismiss"
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <transition name="fade">
                    <login v-if="showLogIn"
                           @loginAdmin="showAdminView"
                           @loginUser="showCampaignView"
                           @alert="showAlert"
                           @close="showMain"
                           @resetClose="showNote">
                    </login>
                </transition>
                <div v-if="!showLogIn">
                    <bread-crumbs :breadcrumbs="this.breadcrumbs"/>
                    <!--<b-container class="mb-3 pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                            <h3 class="info-subtitle palette-primary">{{ $t('common.fair_donation')}}</h3>
                        </b-col>
                    </b-container>-->
                    <b-container class="mb-7 pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                            <h3>{{ $t('common.donation_platform')}}</h3>
                        </b-col>
                    </b-container>
                    <b-container class="pl-0 pr-0 pb-3">
                        <b-col lg="12" class="no-gutters">
                                <h3 class="mb-4 palette-black p-header">{{ $t('info.to_donator')}}</h3>
                                <p class="p-large">{{ $t('info.donator_info_part_1')}}</p>
                                <p class="p-large">{{ $t('info.donator_info_part_2')}}</p>
                                <p class="p-large">{{ $t('info.donator_info_part_2_1')}}</p>
                                <p class="p-large">{{ $t('info.donator_info_part_3')}}</p>
                                <p class="p-large">{{ $t('info.donator_info_part_3_1')}}</p>
                                <p class="p-large">{{ $t('info.donator_info_part_4')}} <br/>{{ $t('common.fair_donation_contact_email')}}</p>
                                <h3 class="mb-4 palette-black p-header">{{ $t('info.contact_details')}}</h3>
                                <p class="p-large mb-0">{{ $t('common.fair_donation_company')}}</p>
                                <p class="p-large mb-0">{{ $t('common.fair_donation_address_details')}}</p>
                                <p  class="p-large"><a href="mailto:info@fairdonation.fi">{{ $t('common.fair_donation_contact_email')}}</a></p>
                                <p class="p-large mb-0">{{ $t('common.fair_donation_chair')}}</p>
                                <p class="p-large mb-0">{{ $t('common.fair_donation_chair_title')}}</p>
                                <p  class="p-large"><a href="mailto:johannes@fairdonation.org">{{ $t('common.fair_donation_chair_email')}}</a></p>
                                <p class="p-large">{{ $t('common.fair_donation_question_answer')}}</p>
                                <p class="p-large mb-0">{{ $t('common.fair_donation_all_in_one_cto')}}</p>
                                <p class="p-large mb-0">{{ $t('common.fair_donation_all_in_one_role')}}</p>
                                <p  class="p-large"><a href="mailto:info@allinonemedia.fi">{{ $t('common.fair_donation_all_in_media_contact')}}</a></p>


                        </b-col>
                        <b-row class="pt-2 pb-4">
                            <b-col sm="12" md="6" class="center">
                                <b-button class="info_button bordered-button" @click.stop="showFaq">
                                    {{ $t('faq.title')}}
                                </b-button>
                            </b-col>
                            <b-col sm="12" md="6" class="center">
                                <b-button class="info_button bordered-button" @click.stop="showLicense">
                                    {{ $t('fund_raising.title')}}
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-container>
                    <category-feed @onCategorySet="setCategory"/>
                </div>
            </div>
            <footer-area />
        </div>
    </div>

</template>

<script>
import Login from "../components/Login";
import Alert from '../components/Alert'
import {alertMixin} from "../mixins/AlertMixin";
import TopBar from "../components/TopBar";
import FooterArea from "../components/FooterArea";
import CategoryFeed from "@/components/feed/CategoryFeed";
import BreadCrumbs from "@/components/BreadCrumbs";

export default {
    name: "InfoView",
    mixins: [alertMixin],
    components: {BreadCrumbs, CategoryFeed, FooterArea, TopBar, Alert, Login},
    data() {
        return {
            showLogIn: false,
            showSearchField: false,
            category: -1,
            note: false,
            breadcrumbs: [
                {
                    text: "breadcrumbs.front_page",
                    translate: true,
                    route: 'main-view',
                    disabled: false,
                    active: false
                },
                {
                    text: "common.fair_donation",
                    translate: true,
                    route: 'info-view',
                    disabled: true,
                    active: true
                }]
        }
    },

    methods: {
        searchView : function () {
            this.showLogIn = false
            this.$router.push({name: 'search-view'})
        },

        showLogin: function () {
            this.showLogIn = true
        },

        showMain: function () {
            this.showLogIn = false
        },

        showNote: function () {
            this.note = true
            this.showAlert(this.$t('login.link_send'), "info")
        },

        alertDismiss: function () {
            if (this.note) {
                this.showLogIn = false
                this.note = false
            }
        },

        setCategory(category) {
            this.category = category
            this.$router.push({name: 'category-organizations-view', params: {id: category}})
        },

        showAdminView: function () {
          this.showLogIn = false
          this.$router.push({name: 'admin-view'})
        },

        showCampaignView: function () {
          this.showLogIn = false
        },

        showFaq : function () {
            this.showLogIn = false
            this.$router.push({name: 'faq-view'})
        },

        showLicense : function () {
            this.showLogIn = false
            this.$router.push({name: 'fund-raising-info-view'})
        },
    }
}
</script>

<style scoped>
.bordered-button {
    color: #34D2FF;
    border-color: #34D2FF;
}

.bordered-button:hover {
    color: #FFFFFF;
}

</style>